import { useState } from 'react'

import { Input, Popup, Toast } from 'antd-mobile'

import { cn, handleSearchInputTrack } from '@/utils'
import imgNoContent from '@/assets/images/noData.png'
import DiscoverResult from './DiscoverResult'
import { IHistory, useLocalStorageHistory } from './hooks/useLocalStorageHistory'
import { useSearchAuthor } from './hooks/useSearchAuthor'
import { useSearchDiscover } from './hooks/useSearchDiscover'
import PeopleResult from './PeopleResult'
import Icon from '@/components/Icon'
import { useAtomValue } from 'jotai'
import { mobileStatusAtom } from '@/store'
const DISCOVER_MODE = 'discover'
const PEOPLE_MODE = 'People'

const SearchInfo = () => {
  const [visibleCloseRight, setVisibleCloseRight] = useState(false)
  // const [openDelete, setOpenDelete] = useState(false)
  const [searchVal, setSearchVal] = useState('')
  const [currentNav, setCurrentNav] = useState(DISCOVER_MODE)
  const { setHistoryStorage, deleteAllHistory, history } = useLocalStorageHistory()
  const isMobile = useAtomValue(mobileStatusAtom)

  const {
    data: discoverData,
    handleSearchData: handleSearchDiscoverData,
    mutate: discoverMutate,
    loadMore: discoverLoadMore,
    loading: discoverLoading,
    loadingMore: discoverLoadingMore,
    noMore: discoverNoMore,
    abortControllerRef: discoverAbortRef,
  } = useSearchDiscover('discoverResult')
  const {
    data: authorData,
    handleSearchData: handleSearchAuthorData,
    mutate: authorMutate,
    loadMore: authorLoadMore,
    loading: authorLoading,
    loadingMore: authorLoadingMore,
    noMore: authorNoMore,
    abortControllerRef: authorAbortRef,
  } = useSearchAuthor('peopleResult')

  const [showHistory, setShowHistory] = useState(true)

  const handleSearchDiscoverLoadMore = () => {
    if (discoverLoading || discoverLoadingMore || discoverNoMore) return
    discoverLoadMore()
  }

  const handleSearchAuthorLoadMore = () => {
    if (authorLoading || authorLoadingMore || authorNoMore) return
    authorLoadMore()
  }

  return (
    <div className='flex h-[45px] w-[45px] items-center justify-center'>
      <Icon
        name='Search'
        className='guide-search h-full w-full cursor-pointer object-contain'
        onClick={() => {
          setVisibleCloseRight(true)
        }}
      />

      <Popup
        position='right'
        visible={visibleCloseRight}
        destroyOnClose
        bodyClassName='h-[100dvh] w-[100vw] md:h-full md:w-[40%]'
        afterClose={() => {
          // 重置项
          setCurrentNav(DISCOVER_MODE)
          setSearchVal('')
          discoverMutate({ list: [], count: 0 })
          authorMutate({ list: [], count: 0 })
          setShowHistory(true)
        }}
      >
        <div className='relative h-full w-full overflow-hidden bg-base-color'>
          <div className='z-[100] mb-[37px] flex h-[104px] w-full items-center bg-base-color px-[37px]'>
            <div className='relative flex w-full items-center'>
              <Icon
                className='h-[37px] w-[37px] cursor-pointer'
                onClick={() => {
                  setVisibleCloseRight(false)
                }}
                name={isMobile ? 'Back' : 'Cancel'}
                width='100%'
                height='100%'
              />
              <Input
                className='ml-[37px] h-[67px] flex-1 rounded-[11px] bg-novel-detail-button-box-color [&_.adm-input-clear]:flex [&_.adm-input-clear]:items-center [&_.adm-input-clear]:justify-center [&_input]:pl-[58px] [&_input]:font-geologica [&_input]:text-[26px] [&_input]:font-normal [&_input]:leading-[41px] [&_input]:text-base-text-color'
                value={searchVal}
                maxLength={200}
                autoFocus
                onChange={(val) => {
                  if (!val.trim()) {
                    if (discoverLoading || discoverLoadingMore) {
                      discoverAbortRef.current?.abort()
                    }
                    if (authorLoading || authorLoadingMore) {
                      authorAbortRef.current?.abort()
                    }
                    setShowHistory(true)
                    authorMutate({ list: [], count: 0 })
                    discoverMutate({ list: [], count: 0 })
                  }
                  setSearchVal(val)
                }}
                onFocus={() => {
                  handleSearchInputTrack()
                }}
                onEnterPress={(e) => {
                  const value = (e.target as HTMLInputElement).value
                  if (!value.trim()) return
                  if (value === searchVal && (discoverLoading || discoverLoadingMore || authorLoading || authorLoadingMore)) return

                  if (currentNav === DISCOVER_MODE && value) {
                    handleSearchDiscoverData(value)
                  }
                  if (currentNav === PEOPLE_MODE && value) {
                    handleSearchAuthorData(value)
                  }
                  setHistoryStorage(value)
                  setShowHistory(false)
                  // setOpenDelete(false)
                }}
                clearable={true}
                enterKeyHint='search'
                clearIcon={
                  <Icon
                    name='Cancel'
                    className='h-[45px] w-[45px]'
                    onClick={(e) => {
                      e.stopPropagation()

                      if (discoverLoading || discoverLoadingMore) {
                        discoverAbortRef.current?.abort()
                      }
                      if (authorLoading || authorLoadingMore) {
                        authorAbortRef.current?.abort()
                      }

                      setSearchVal('')
                      setShowHistory(true)
                      discoverMutate({ list: [], count: 0 })
                      authorMutate({ list: [], count: 0 })
                    }}
                  />
                }
              />
              <Icon name='Search' className='absolute left-[93px] top-1/2 h-[30px] w-[30px] -translate-y-1/2 opacity-20' />
            </div>
          </div>
          {showHistory && history.length ? (
            <div className='px-[37px]'>
              <div className='mb-[22px] flex items-center justify-between'>
                <span className='font-geologica text-[30px] font-normal leading-[41px] text-base-text-color'>History</span>
                <div className='flex items-center'>
                  {/* {openDelete ? (
                    <span
                      className='mr-[30px] cursor-pointer font-geologica text-[26px] font-normal text-base-text-color'
                      onClick={() => {
                        deleteAllHistory()
                        Toast.show({
                          position: 'top',
                          content: 'Delete All Successfully',
                        })
                      }}
                    >
                      Delete all
                    </span>
                  ) : null} */}
                  {/* {openDelete ? (
                    <Icon
                      className='h-[30px] w-[30px] cursor-pointer'
                      name='Cancel'
                      onClick={() => {
                        setOpenDelete(false)
                      }}
                    />
                  ) : (
                    <Icon
                      className='h-[30px] w-[30px] cursor-pointer'
                      name='Delete'
                      onClick={() => {
                        setOpenDelete(true)
                      }}
                    />
                  )} */}
                  <Icon
                    className='h-[30px] w-[30px] cursor-pointer'
                    name='Delete'
                    onClick={() => {
                      deleteAllHistory()
                      Toast.show({
                        position: 'top',
                        content: 'Delete Successfully',
                      })
                    }}
                  />
                </div>
              </div>

              <div className='flex flex-wrap items-center justify-start'>
                {history.map((item: IHistory) => {
                  return (
                    <div
                      className='relative mb-[15px] mr-[15px] flex h-[56px] cursor-pointer items-center rounded-[15px] bg-novel-detail-button-box-color px-[22px]'
                      key={item.searchTime}
                      onClick={() => {
                        setSearchVal(item.searchKey)
                        setHistoryStorage(item.searchKey)
                        if (currentNav === DISCOVER_MODE && item.searchKey) {
                          handleSearchDiscoverData(item.searchKey)
                        }
                        if (currentNav === PEOPLE_MODE && item.searchKey) {
                          handleSearchAuthorData(item.searchKey)
                        }
                        setShowHistory(false)
                      }}
                    >
                      <span className='line-clamp-1 break-all font-geologica text-[22px] font-normal text-base-text-color'>{item.searchKey}</span>
                      {/* {openDelete ? (
                        <Icon
                          name='Cancel'
                          className='absolute right-[-10px] top-[-10px] h-[30px] w-[30px] rounded-full bg-[#5e5e5e]'
                          onClick={(e) => {
                            e.stopPropagation()
                            deleteHistory(item.searchKey)
                          }}
                        />
                      ) : null} */}
                    </div>
                  )
                })}
              </div>
            </div>
          ) : null}
          <div className={cn('h-[calc(100dvh-141px)]', showHistory && history.length && 'mt-[90px]')}>
            <div className='mb-[37px] flex h-[62px] items-center justify-start px-[37px]'>
              <div
                className={cn(
                  'relative mr-[60px] flex cursor-pointer items-center justify-center font-geologica text-[30px] font-normal leading-[41px] text-base-text-color opacity-60',
                  currentNav === DISCOVER_MODE &&
                    "opacity-100 after:absolute after:bottom-[-15px] after:left-1/2 after:h-[6px] after:w-[30px] after:-translate-x-1/2 after:rounded-[4px] after:bg-base-text-color after:content-['']",
                )}
                onClick={() => {
                  setCurrentNav(DISCOVER_MODE)
                  if (searchVal) {
                    setShowHistory(false)
                    handleSearchDiscoverData(searchVal)
                  }
                }}
              >
                Stories
              </div>
              <div
                className={cn(
                  'relative mr-[60px] flex cursor-pointer items-center justify-center font-geologica text-[30px] font-normal leading-[41px] text-base-text-color opacity-60',
                  currentNav === PEOPLE_MODE &&
                    "opacity-100 after:absolute after:bottom-[-15px] after:left-1/2 after:h-[6px] after:w-[30px] after:-translate-x-1/2 after:rounded-[4px] after:bg-base-text-color after:content-['']",
                )}
                onClick={() => {
                  setCurrentNav(PEOPLE_MODE)
                  if (searchVal) {
                    handleSearchAuthorData(searchVal)
                  }
                }}
              >
                People
              </div>
            </div>
            {currentNav === DISCOVER_MODE ? (
              <DiscoverResult
                showHistory={showHistory}
                data={discoverData?.list?.filter?.((item) => !!item.resource_id) || []}
                loading={discoverLoading}
                loadingMore={discoverLoadingMore}
                noMore={discoverNoMore}
                onLoadMore={handleSearchDiscoverLoadMore}
                handleSearchTrending={(val) => {
                  handleSearchDiscoverData(val)
                }}
                setHistoryStorage={(val) => {
                  setHistoryStorage(val)
                  setSearchVal(val)
                  setShowHistory(false)
                }}
              />
            ) : null}
            {currentNav === PEOPLE_MODE ? (
              <PeopleResult
                data={authorData?.list || []}
                loading={authorLoading}
                loadingMore={authorLoadingMore}
                noMore={authorNoMore}
                onLoadMore={handleSearchAuthorLoadMore}
              />
            ) : null}
            {!currentNav ? (
              <div className='noContentBox mt-[40px] flex flex-col items-center justify-center'>
                <img src={imgNoContent} className='mb-[15px] w-[100px]' />
                <span className='font-helvetica text-center text-[22px] text-[#999999]'>Search for stories or people</span>
              </div>
            ) : null}
          </div>
        </div>
      </Popup>
    </div>
  )
}

export default SearchInfo
